module.exports = __webpack_public_path__ + "static/media/iq.3f196296.svg";